{
  "name": "@kakaopay-develop/agent-toolkit",
  "version": "0.1.2",
  "description": "KakaoPay Agent Toolkit",
  "homepage": "https://github.com/kakaopay-develop/agent-toolkit",
  "repository": {
    "type": "git",
    "url": "https://github.com/kakaopay-develop/agent-toolkit.git"
  },
  "bugs": {
    "url": "https://github.com/kakaopay-develop/agent-toolkit/issues"
  },
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "build": "tsup",
    "test": "jest",
    "lint": "eslint \"./**/*.ts*\"",
    "prettier": "prettier './**/*.{js,ts,md,html,css}' --write",
    "prettier-check": "prettier './**/*.{js,ts,md,html,css}' --check",
    "clean": "rm -rf modelcontextprotocol ai-sdk openai langchain bedrock",
    "dev": "tsup --watch"
  },
  "exports": {
    "./modelcontextprotocol": {
      "types": "./modelcontextprotocol/index.d.ts",
      "require": "./modelcontextprotocol/index.js",
      "import": "./modelcontextprotocol/index.mjs"
    },
    "./ai-sdk": {
      "types": "./ai-sdk/index.d.ts",
      "require": "./ai-sdk/index.js",
      "import": "./ai-sdk/index.mjs"
    },
    "./openai": {
      "types": "./openai/index.d.ts",
      "require": "./openai/index.js",
      "import": "./openai/index.mjs"
    },
    "./langchain": {
      "types": "./langchain/index.d.ts",
      "require": "./langchain/index.js",
      "import": "./langchain/index.mjs"
    },
    "./bedrock": {
      "types": "./bedrock/index.d.ts",
      "require": "./bedrock/index.js",
      "import": "./bedrock/index.mjs"
    }
  },
  "dependencies": {
    "@langchain/core": "^0.3.6",
    "@modelcontextprotocol/sdk": "^1.6.1",
    "ai": "^4.3.16",
    "axios": "^1.6.7",
    "openai": "^5.8.2",
    "zod": "^3.22.4",
    "zod-to-json-schema": "^3.22.4"
  },
  "devDependencies": {
    "@eslint/compat": "^1.3.1",
    "@eslint/eslintrc": "^3.3.1",
    "@types/node": "^20.11.19",
    "@typescript-eslint/eslint-plugin": "^8.37.0",
    "@typescript-eslint/parser": "^8.37.0",
    "eslint": "^9.31.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-prettier": "^5.5.3",
    "globals": "^16.3.0",
    "jest": "^29.7.0",
    "prettier": "^3.6.2",
    "ts-jest": "^29.1.2",
    "tsup": "^8.5.0",
    "typescript": "^5.3.3"
  },
  "keywords": [
    "kakaopay",
    "payment",
    "agent",
    "ai",
    "toolkit",
    "langchain"
  ],
  "author": "KakaoPay <kakaopay.developer@kakaopaycorp.com>",
  "license": "MIT",
  "files": [
    "modelcontextprotocol/**/*",
    "ai-sdk/**/*",
    "openai/**/*",
    "langchain/**/*",
    "bedrock/**/*",
    "LICENSE",
    "README.md",
    "package.json"
  ]
}
